// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* overridden by src/lib/themes/guiHelpers.js */

/* make sure to keep these in sync with other constants,
e.g. STAGE_DIMENSION_DEFAULTS in lib/screen-utils.js */

/* layout contants from \`layout-constants.js\` */

.library-item_library-item_zeYsO {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    flex-basis: 175px;
    position: relative;
    max-width: 175px;
    margin: 0.5rem;
    font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
    color: var(--text-primary);
    background: var(--ui-white);
    border-width: 2px;
    border-style: solid;
    border-color: var(--ui-black-transparent);
    border-radius: 0.5rem;
    text-align: center;
    cursor: pointer;
    overflow: hidden;
}

.library-item_library-item_zeYsO:hover {
    border-width: 2px;
    border-color: var(--looks-secondary);
}

.library-item_hidden_zFAij {
    display: none;
}

.library-item_library-item-image-container-wrapper_KJLCv {
    height: 100px;
    width: 100%;
    position: relative;
    padding: 0.5rem 0.5rem 0 0.5rem;
}

.library-item_library-item-image-container_rKUCR {
    position: absolute;
    height: calc(100px - 0.5rem);
    width: calc(100% - 0.5rem * 2);
}

.library-item_library-item-inset-image-container_aI9ii {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: -2.5rem;
    align-self: flex-start;
    background-color: var(--pen-primary);
    width: 3.5rem;
    height: 3.5rem;
    border-radius: 0.5rem;
    border: 0.25rem solid var(--ui-white);
}

[dir="ltr"] .library-item_library-item-inset-image-container_aI9ii {
    margin-left: 1rem;
}

[dir="rtl"] .library-item_library-item-inset-image-container_aI9ii {
    margin-right: 1rem;
}

.library-item_library-item-image__Wo7C {
    max-width: 100%;
    max-height: 100%;
}

.library-item_library-item-inset-image_MZ7BZ {
    width: 2.5rem;
}

.library-item_featured-text__aRQV {
    font-weight: bold;
    padding: 10px;
    width: 100%;
}

[dir="ltr"] .library-item_featured-text__aRQV {
    text-align: left;
    padding-left: 1.25rem;
}

[dir="rtl"] .library-item_featured-text__aRQV {
    text-align: right;
    padding-right: 1.25rem;
}

.library-item_featured-description_rbqcP {
    display: block;
    font-weight: normal;
    line-height: 1.375rem;
    padding-top: .3125rem;
    padding-bottom: .25rem;
}

.library-item_featured-thin-description_luZU5 {
    display: block;
    font-weight: normal;
    font-size: 12px;
    padding-top: .3125rem;
    padding-bottom: .25rem;
}

.library-item_library-item-metadata_tfGUm {
    width: 100%;
    padding: 0 1.25rem 1rem 1.25rem;
    display: grid;
    grid-template-columns: 1fr;
    gap: .5rem;
    align-items: start;
    font-size: 12px;
    color: var(--text-primary);
    opacity: 0.75;
}

[dir="ltr"] .library-item_library-item-metadata_tfGUm {
    text-align: left;
}

[dir="rtl"] .library-item_library-item-metadata_tfGUm {
    text-align: right;
}

.library-item_library-item-metadata-section_wnakj {
    width: 100%;
    display: flex;
    flex-direction: column;
}

.library-item_library-item-metadata-detail_vs8kg {
    height: 100%;
    padding-top: 0.4rem;
    font-weight: bold;
}

.library-item_library-item-metadata-detail_vs8kg img {
    margin-right: 0.25rem;
    width: 20px;
    height: 20px;
}

.library-item_favorite-container_TieLd {
    display: none;
    background: none;
    border: none;
    padding: 0;
    margin: 0;
    position: absolute;
    top: 0.5rem;
    left: 0.5rem;
}

.library-item_favorite-icon_QF8EY {
    width: 32px;
    height: 32px;
}

.library-item_favorite-container_TieLd.library-item_active_bozcD,
.library-item_library-item_zeYsO:hover .library-item_favorite-container_TieLd {
    display: block;
}
`, "",{"version":3,"sources":["webpack://./src/components/library-item/library-item.css"],"names":[],"mappings":"AAAA,+CAA+C;;AAE/C;sDACsD;;AAEtD,+CAA+C;;AAE/C;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,2BAA2B;IAC3B,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,2DAA2D;IAC3D,0BAA0B;IAC1B,2BAA2B;IAC3B,iBAAiB;IACjB,mBAAmB;IACnB,yCAAyC;IACzC,qBAAqB;IACrB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,oCAAoC;AACxC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,WAAW;IACX,kBAAkB;IAClB,+BAA+B;AACnC;;AAEA;IACI,kBAAkB;IAClB,4BAA4B;IAC5B,8BAA8B;AAClC;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,sBAAsB;IACtB,oCAAoC;IACpC,aAAa;IACb,cAAc;IACd,qBAAqB;IACrB,qCAAqC;AACzC;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,iBAAiB;IACjB,aAAa;IACb,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,iBAAiB;IACjB,sBAAsB;AAC1B;;AAEA;IACI,cAAc;IACd,mBAAmB;IACnB,qBAAqB;IACrB,qBAAqB;IACrB,sBAAsB;AAC1B;;AAEA;IACI,cAAc;IACd,mBAAmB;IACnB,eAAe;IACf,qBAAqB;IACrB,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,+BAA+B;IAC/B,aAAa;IACb,0BAA0B;IAC1B,UAAU;IACV,kBAAkB;IAClB,eAAe;IACf,0BAA0B;IAC1B,aAAa;AACjB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,YAAY;IACZ,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,qBAAqB;IACrB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,YAAY;IACZ,UAAU;IACV,SAAS;IACT,kBAAkB;IAClB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;;IAEI,cAAc;AAClB","sourcesContent":["/* overridden by src/lib/themes/guiHelpers.js */\n\n/* make sure to keep these in sync with other constants,\ne.g. STAGE_DIMENSION_DEFAULTS in lib/screen-utils.js */\n\n/* layout contants from `layout-constants.js` */\n\n.library-item {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: flex-start;\n    flex-basis: 175px;\n    position: relative;\n    max-width: 175px;\n    margin: 0.5rem;\n    font-family: \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n    color: var(--text-primary);\n    background: var(--ui-white);\n    border-width: 2px;\n    border-style: solid;\n    border-color: var(--ui-black-transparent);\n    border-radius: 0.5rem;\n    text-align: center;\n    cursor: pointer;\n    overflow: hidden;\n}\n\n.library-item:hover {\n    border-width: 2px;\n    border-color: var(--looks-secondary);\n}\n\n.hidden {\n    display: none;\n}\n\n.library-item-image-container-wrapper {\n    height: 100px;\n    width: 100%;\n    position: relative;\n    padding: 0.5rem 0.5rem 0 0.5rem;\n}\n\n.library-item-image-container {\n    position: absolute;\n    height: calc(100px - 0.5rem);\n    width: calc(100% - 0.5rem * 2);\n}\n\n.library-item-inset-image-container {\n    position: relative;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin-top: -2.5rem;\n    align-self: flex-start;\n    background-color: var(--pen-primary);\n    width: 3.5rem;\n    height: 3.5rem;\n    border-radius: 0.5rem;\n    border: 0.25rem solid var(--ui-white);\n}\n\n[dir=\"ltr\"] .library-item-inset-image-container {\n    margin-left: 1rem;\n}\n\n[dir=\"rtl\"] .library-item-inset-image-container {\n    margin-right: 1rem;\n}\n\n.library-item-image {\n    max-width: 100%;\n    max-height: 100%;\n}\n\n.library-item-inset-image {\n    width: 2.5rem;\n}\n\n.featured-text {\n    font-weight: bold;\n    padding: 10px;\n    width: 100%;\n}\n\n[dir=\"ltr\"] .featured-text {\n    text-align: left;\n    padding-left: 1.25rem;\n}\n\n[dir=\"rtl\"] .featured-text {\n    text-align: right;\n    padding-right: 1.25rem;\n}\n\n.featured-description {\n    display: block;\n    font-weight: normal;\n    line-height: 1.375rem;\n    padding-top: .3125rem;\n    padding-bottom: .25rem;\n}\n\n.featured-thin-description {\n    display: block;\n    font-weight: normal;\n    font-size: 12px;\n    padding-top: .3125rem;\n    padding-bottom: .25rem;\n}\n\n.library-item-metadata {\n    width: 100%;\n    padding: 0 1.25rem 1rem 1.25rem;\n    display: grid;\n    grid-template-columns: 1fr;\n    gap: .5rem;\n    align-items: start;\n    font-size: 12px;\n    color: var(--text-primary);\n    opacity: 0.75;\n}\n\n[dir=\"ltr\"] .library-item-metadata {\n    text-align: left;\n}\n\n[dir=\"rtl\"] .library-item-metadata {\n    text-align: right;\n}\n\n.library-item-metadata-section {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n}\n\n.library-item-metadata-detail {\n    height: 100%;\n    padding-top: 0.4rem;\n    font-weight: bold;\n}\n\n.library-item-metadata-detail img {\n    margin-right: 0.25rem;\n    width: 20px;\n    height: 20px;\n}\n\n.favorite-container {\n    display: none;\n    background: none;\n    border: none;\n    padding: 0;\n    margin: 0;\n    position: absolute;\n    top: 0.5rem;\n    left: 0.5rem;\n}\n\n.favorite-icon {\n    width: 32px;\n    height: 32px;\n}\n\n.favorite-container.active,\n.library-item:hover .favorite-container {\n    display: block;\n}\n"],"sourceRoot":""}]);
// Exports
var _1 = `library-item_library-item_zeYsO`;
export { _1 as "library-item" };
export var libraryItem = `library-item_library-item_zeYsO`;
export var hidden = `library-item_hidden_zFAij`;
var _2 = `library-item_library-item-image-container-wrapper_KJLCv`;
export { _2 as "library-item-image-container-wrapper" };
export var libraryItemImageContainerWrapper = `library-item_library-item-image-container-wrapper_KJLCv`;
var _3 = `library-item_library-item-image-container_rKUCR`;
export { _3 as "library-item-image-container" };
export var libraryItemImageContainer = `library-item_library-item-image-container_rKUCR`;
var _4 = `library-item_library-item-inset-image-container_aI9ii`;
export { _4 as "library-item-inset-image-container" };
export var libraryItemInsetImageContainer = `library-item_library-item-inset-image-container_aI9ii`;
var _5 = `library-item_library-item-image__Wo7C`;
export { _5 as "library-item-image" };
export var libraryItemImage = `library-item_library-item-image__Wo7C`;
var _6 = `library-item_library-item-inset-image_MZ7BZ`;
export { _6 as "library-item-inset-image" };
export var libraryItemInsetImage = `library-item_library-item-inset-image_MZ7BZ`;
var _7 = `library-item_featured-text__aRQV`;
export { _7 as "featured-text" };
export var featuredText = `library-item_featured-text__aRQV`;
var _8 = `library-item_featured-description_rbqcP`;
export { _8 as "featured-description" };
export var featuredDescription = `library-item_featured-description_rbqcP`;
var _9 = `library-item_featured-thin-description_luZU5`;
export { _9 as "featured-thin-description" };
export var featuredThinDescription = `library-item_featured-thin-description_luZU5`;
var _a = `library-item_library-item-metadata_tfGUm`;
export { _a as "library-item-metadata" };
export var libraryItemMetadata = `library-item_library-item-metadata_tfGUm`;
var _b = `library-item_library-item-metadata-section_wnakj`;
export { _b as "library-item-metadata-section" };
export var libraryItemMetadataSection = `library-item_library-item-metadata-section_wnakj`;
var _c = `library-item_library-item-metadata-detail_vs8kg`;
export { _c as "library-item-metadata-detail" };
export var libraryItemMetadataDetail = `library-item_library-item-metadata-detail_vs8kg`;
var _d = `library-item_favorite-container_TieLd`;
export { _d as "favorite-container" };
export var favoriteContainer = `library-item_favorite-container_TieLd`;
var _e = `library-item_favorite-icon_QF8EY`;
export { _e as "favorite-icon" };
export var favoriteIcon = `library-item_favorite-icon_QF8EY`;
export var active = `library-item_active_bozcD`;
export default ___CSS_LOADER_EXPORT___;
